import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useAsyncCallback } from 'react-async-hook';
import { useCodeStore } from '../store/use-code-store';
import { useInviteStore } from '../store/use-invite-store';
import { api } from './instance';
import { decorateError } from './utils';

dayjs.extend(customParseFormat);

export function useRequestOtp() {
  const { setInvite, invite } = useInviteStore();
  const { previousName, previousDob, resetExpiresAt } = useCodeStore();

  return useAsyncCallback(async (maybeFamilyName, maybeDob) => {
    const bookingReference = invite?.reference;
    const familyName = maybeFamilyName ?? previousName;
    const dateOfBirth = maybeDob ? maybeDob : previousDob;

    try {
      const response = await api.public
        .post('onlinebooking/request-otp', {
          json: {
            onlineBookingReference: bookingReference,
            familyName,
            dateOfBirth,
          },
        })
        .json();
      resetExpiresAt(response.expiryDateTime, familyName, dateOfBirth);
      return true;
    } catch (error) {
      switch (error.response?.status) {
        case 400: {
          throw decorateError(error, 'errors.invalidOtp.title', 'errors.invalidOtp.details');
        }
        case 409: {
          // Not throwing to avoid error message flash
          setInvite({ status: 'locked' });
          break;
        }
      }
      throw decorateError(error, 'errors.serverErrorOtp.title', 'errors.serverErrorOtp.details');
    }
  });
}
